<template>
    <div class="movie-gradient movie-goback" :style="style">
        <span class="arrow" @click.stop="goBack()" :style="arrowStyle"><i class="iconfont icon-xiangzuo"></i></span>
        <div class="page-title" :style="titleStyle">{{text}}</div>
    </div>
</template>

<script>
export default {
    name:"MovieGoBack",
    props:{
        text:"",
        style: {},
        arrowStyle: {},
        titleStyle: {}
    },
    data:function(){
        return {
        }
    },
    methods: {
        goBack(){
            this.$router.back();
        }
    }

}
</script>

<style scoped>
.movie-goback{
    width:100%;
    height:.88rem;
    box-sizing: border-box;
    padding:0 .8rem;
    line-height: .88rem;
    position:relative;
}
.arrow{
    color:white;
    font-size: .34rem;
    position:absolute;
    left:.3rem;
    top:50%;
    transform: translate(0,-50%);
}
.page-title{
    color:white;
    font-size:.32rem;
}

</style>
